import React from "react";
import { useTranslation } from "react-i18next";
import { MessageStatus } from "../enums/messageStatus";


interface Props {
  statusCode: MessageStatus;
}

const MessageStatusLabel = ({ statusCode }: Props) => {
  // translations
  const tLabels = useTranslation("messages\\enums\\messageState").t;

  // render
  switch (statusCode) {
    case "Read":
      return (
        <span className="badge badge-pill badge-success small font-weight-normal">
          {tLabels(statusCode)}
        </span>
      );
    case "Unread":
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal">
          {tLabels(statusCode)}
        </span>
      );
    default:
      return null;
  }
};

export default MessageStatusLabel;
